import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Simple event bus to request that any visible datalist views reload their data.
 * This avoids brittle parent/child wiring when actions live in shared components (like PageHeader).
 */
@Injectable({
  providedIn: 'root'
})
export class DatalistRefreshService {
  private readonly _refreshRequested = new Subject<void>();

  /** Fired when a datalist refresh is requested. */
  public readonly refreshRequested$ = this._refreshRequested.asObservable();

  /** Request that datalist views refresh their data. */
  public requestRefresh(): void {
    this._refreshRequested.next();
  }
}

